const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const AIStudioAnalyticsQueryURL: any = {
    GetAnalytics: Backofficebff + '/v1/aistudioanalytics',
    GetFilteredStats: Backofficebff + '/v1/aistudioanalytics/filtered-stats',
    GetUserTransactions: (username: string) => Backofficebff + `/v1/aistudioanalytics/user-transactions/${username}`,
    GetTransactionDetail: (id: number) => Backofficebff + `/v1/aistudioanalytics/transaction-detail/${id}`,
    GetProductGenerationReport: Backofficebff + '/v1/aistudioanalytics/product-generation-report',
};

